webpackJsonp([161693943661162],{

/***/ 1651:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/people/sophie-baldwin/","posts":[{"fields":{"slug":"/news/introducing-sophie-baldwin/","author":{"id":"/opt/build/repo/src/pages/people/sophie-baldwin.md absPath of file >>> MarkdownRemark"}},"frontmatter":{"title":"Introducing... Sophie Baldwin","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450 introducing sophie baldwin article header-d2f7e935d5f333236b87bb6da17a48b8.jpg"}}},"original":"/img/1160x450 introducing sophie baldwin article header.jpg"},"category":"Culture"}}]},"frontmatter":{"title":"Sophie Baldwin"}}}]}},"pathContext":{"author":"/people/sophie-baldwin/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---authors-sophie-baldwin-3ff25ff36c74fd1e53e7.js